import { Zap, Wrench, Hammer, Brush, Building, Wind, Sparkles, Building2, Briefcase } from "lucide-react";

export const INDUSTRIES = [
    {
        key: "elektriker",
        name: "Elektriker",
        icon: Zap,
        short: "MyServiceHelper hjælper elektrikere med jobstyring, dokumentation og tidsregistrering.",
        intro: "MyServiceHelper hjælper elektrikere med at samle kundehenvendelser, hasteopgaver, serviceaftaler, dokumentation og tidsregistrering ét sted.",
        challenges: [
            "Akutte opgaver kommer ind via telefon og SMS",
            "Opgaver kan mangle adresse, billeder eller fejlbeskrivelse",
            "Medarbejdere skal ringes op for status",
            "Tid og materialer bliver ofte registreret bagefter",
        ],
        helps: [
            "Opretter kunde og job ud fra henvendelsen",
            "Sender opgaven videre til medarbejder",
            "Samler tid, materialer og noter",
            "Gør opgaven klar til faktura og opfølgning",
        ],
        example: "Kunden melder om strømsvigt eller defekt stikkontakt. Systemet registrerer adresse, prioritet, opgave og sender sagen videre til den rette medarbejder.",
    },
    {
        key: "vvs",
        name: "VVS",
        icon: Wrench,
        short: "MyServiceHelper gør det nemt for VVS-virksomheder at styre opgaver, materialer og fakturering.",
        intro: "MyServiceHelper hjælper VVS-virksomheder med at håndtere akutte sager, serviceopgaver, materialeforbrug og dokumentation.",
        challenges: [
            "Akutte vand- og varmesager kræver hurtig respons",
            "Materialer skal registreres korrekt",
            "Kunden skal holdes opdateret",
            "Kontoret mangler ofte status fra marken",
        ],
        helps: [
            "Samler kundeoplysninger og opgavebeskrivelse",
            "Prioriterer akutte opgaver",
            "Medarbejderen kan registrere tid og materialer",
            "Kontoret får samlet fakturagrundlag",
        ],
        example: "Kunden melder om utæt rør. Systemet opretter opgaven, sender den til medarbejderen og samler materialer, tid og noter efter udførelse.",
    },
    {
        key: "tomrer",
        name: "Tømrer",
        icon: Hammer,
        short: "MyServiceHelper samler opgaver, materialer og tegninger ét sted og skaber overblik.",
        intro: "MyServiceHelper hjælper tømrere med at holde styr på projekter, serviceopgaver, dokumentation, materialer og kundekontakt.",
        challenges: [
            "Projekter består af mange små beskeder og aftaler",
            "Materialer og noter kan blive spredt",
            "Kunden vil gerne have status",
            "Opgavehistorik kan være svær at finde",
        ],
        helps: [
            "Samler opgavebeskrivelse og kundedata",
            "Giver overblik over aktive opgaver",
            "Registrerer noter, tid og materialer",
            "Gør afslutning og opfølgning lettere",
        ],
        example: "Kunden ønsker reparation eller mindre renovering. Systemet samler billeder, noter, adresse og status, så kontor og medarbejder arbejder ud fra samme information.",
    },
    {
        key: "maler",
        name: "Maler",
        icon: Brush,
        short: "MyServiceHelper hjælper malerfirmaer med at planlægge, udføre og dokumentere opgaver.",
        intro: "MyServiceHelper hjælper malerfirmaer med planlægning, opgavestyring, kundedialog og dokumentation.",
        challenges: [
            "Opgaver afhænger ofte af rum, overflader og materialer",
            "Der kan være flere aftaler med samme kunde",
            "Noter og billeder skal gemmes",
            "Opfølgning kan blive glemt",
        ],
        helps: [
            "Samler kundens ønsker og opgavedetaljer",
            "Opretter job og planlægning",
            "Gør det let at registrere noter og materialer",
            "Samler dokumentation til kontoret",
        ],
        example: "Kunden ønsker maling af flere rum. Systemet gemmer adresse, rum, noter, materialer og medarbejderstatus.",
    },
    {
        key: "murer",
        name: "Murer",
        icon: Building,
        short: "MyServiceHelper giver murere styr på opgaver, materialer og tidsforbrug.",
        intro: "MyServiceHelper hjælper murere med at styre opgaver, materialer, tidsforbrug og dokumentation.",
        challenges: [
            "Materialeforbrug skal være præcist",
            "Opgaver kræver ofte noter og billeder",
            "Planlægning kan være afhængig af vejr, adgang og andre faggrupper",
            "Kontoret mangler færdigmelding og dokumentation",
        ],
        helps: [
            "Samler opgaveinformation ét sted",
            "Registrerer tid, materialer og noter",
            "Giver kontoret status uden ekstra opkald",
            "Gør fakturagrundlaget mere komplet",
        ],
        example: "Kunden bestiller reparation af murværk. Systemet opretter opgaven, medarbejderen registrerer materialer og færdigmelder med noter.",
    },
    {
        key: "ventilation",
        name: "Ventilation",
        icon: Wind,
        short: "MyServiceHelper hjælper ventilationsvirksomheder med serviceaftaler og effektiv opgavehåndtering.",
        intro: "MyServiceHelper hjælper ventilationsvirksomheder med serviceaftaler, fejlmeldinger, planlægning og dokumentation.",
        challenges: [
            "Serviceaftaler skal følges systematisk",
            "Fejlmeldinger kræver hurtig registrering",
            "Teknikeren skal dokumentere udført arbejde",
            "Kontoret skal kunne følge status",
        ],
        helps: [
            "Samler serviceopgaver og fejlmeldinger",
            "Sender opgaver til tekniker",
            "Registrerer tid, noter og materialer",
            "Samler dokumentation til opfølgning",
        ],
        example: "Kunden melder dårlig luft eller støj fra anlæg. Systemet opretter sagen og samler teknikerens noter efter service.",
    },
    {
        key: "rengoring",
        name: "Rengøring",
        icon: Sparkles,
        short: "MyServiceHelper gør det nemt at planlægge rengøringsopgaver og dokumentere kvalitet.",
        intro: "MyServiceHelper hjælper rengøringsvirksomheder med planlægning, opgavefordeling, kvalitetssikring og kundedialog.",
        challenges: [
            "Mange faste og gentagne opgaver",
            "Kunden forventer dokumentation og kvalitet",
            "Medarbejdere arbejder ofte ude på flere lokationer",
            "Ændringer i opgaver skal hurtigt kommunikeres",
        ],
        helps: [
            "Samler opgaver og kundeaftaler",
            "Sender besked til medarbejdere",
            "Gør det let at registrere status og noter",
            "Giver kontoret overblik over udførte opgaver",
        ],
        example: "Kunden ændrer rengøringstidspunkt eller melder ekstra opgave. Systemet opdaterer opgaven og sender besked videre.",
    },
    {
        key: "ejendomsservice",
        name: "Ejendomsservice",
        icon: Building2,
        short: "MyServiceHelper samler drift, vedligehold og opgaver på tværs af ejendomme.",
        intro: "MyServiceHelper hjælper ejendomsservice med drift, vedligehold, beboerhenvendelser og opgavestyring på tværs af ejendomme.",
        challenges: [
            "Mange små opgaver fra beboere og ejendomme",
            "Opgaver kommer via flere kanaler",
            "Status skal deles med kontor og medarbejdere",
            "Drift kræver dokumentation",
        ],
        helps: [
            "Samler henvendelser og opgaver",
            "Knytter opgaver til ejendom/adresse",
            "Sender opgaver til rette medarbejder",
            "Samler status, noter og dokumentation",
        ],
        example: "En beboer melder defekt lys eller skade. Systemet opretter sagen, sender den videre og gemmer dokumentation efter udførelse.",
    },
    {
        key: "servicefirma",
        name: "Servicefirma",
        icon: Briefcase,
        short: "MyServiceHelper giver servicefirmaer fuld kontrol over opgaver, kunder og opfølgning.",
        intro: "MyServiceHelper hjælper servicefirmaer med at samle opgaver, kunder, medarbejdere, tid og opfølgning i ét flow.",
        challenges: [
            "Mange forskellige opgavetyper",
            "Kundekontakt kan blive ustruktureret",
            "Medarbejdere skal koordineres hurtigt",
            "Kontoret mangler samlet overblik",
        ],
        helps: [
            "Samler alle henvendelser ét sted",
            "Opretter og fordeler opgaver",
            "Registrerer tid, noter og materialer",
            "Giver bedre overblik og hurtigere opfølgning",
        ],
        example: "Kunden sender en serviceopgave. Systemet registrerer sagen, tildeler medarbejder og samler afslutning og dokumentation.",
    },
];

export const INDUSTRIES_BY_KEY = INDUSTRIES.reduce((acc, ind) => {
    acc[ind.key] = ind;
    return acc;
}, {});
